'use strict';

/**
* Form
*
* @author Matthias Giger <matthias.giger@namics.com>
*/
T.Module.Form = T.createModule({

	_selectors: {
		element: '.m-form-element',
		legend: '.m-form-element__legend'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		this.validateForm();

		resolve();
	},


	/**
  * When developing the FE trigger validation here.
  * Validation needs to be triggered before submit.
  *
  * @returns {void}
  **/
	validateForm: function validateForm() {
		var _this = this;

		if (location.hostname !== 'localhost' || typeof $(this).validate === 'undefined') {
			// Use Backend validation.
			return null;
		}

		this.$ctx.validate({
			errorPlacement: function errorPlacement(error, element) {
				var type = element.attr('type');

				if (type === 'radio' || type === 'checkbox') {
					var formElement = element.closest(_this._selectors.element);
					var legend = formElement.find(_this._selectors.legend);
					error.insertAfter(legend);
				} else {
					error.insertAfter(element);
				}
			}
		});
	}
});